import { Fragment } from "react";
import { NavLink } from "./NavLink";
import { StoreDownloadActions } from "./StoreDownloadActions";

export function CardGrid({ cards, navigate, cardOffset = 0, showMobileDownloadPrompts = false }) {
  if (!cards?.length) return null;

  return (
    <div className="card-grid">
      {cards.map((card, index) => (
        <Fragment key={`${card.title}-${card.path || index}`}>
          {card.path ? (
            <NavLink
              to={card.path}
              className="info-card info-card-link"
              onNavigate={navigate}
            >
              {card.icon ? (
                <span className="card-icon" aria-hidden="true">
                  {card.icon}
                </span>
              ) : null}
              <strong>{card.title}</strong>
              <span>{card.text}</span>
            </NavLink>
          ) : (
            <article className="info-card">
              {card.icon ? (
                <span className="card-icon" aria-hidden="true">
                  {card.icon}
                </span>
              ) : null}
              <strong>{card.title}</strong>
              <span>{card.text}</span>
            </article>
          )}
          {showMobileDownloadPrompts && (cardOffset + index + 1) % 3 === 0 ? (
            <aside className="home-mobile-download-prompt" aria-label="Download the CSS MPT app">
              <h3>CSS MPT App</h3>
              <StoreDownloadActions />
            </aside>
          ) : null}
        </Fragment>
      ))}
    </div>
  );
}

export function ImageStrip({ images }) {
  if (!images?.length) return null;

  return (
    <div className="image-strip" aria-label="Aspirant visuals">
      {images.map((image) => (
        <figure key={image.src} className="image-tile">
          <img src={image.src} alt={image.alt} loading="lazy" />
        </figure>
      ))}
    </div>
  );
}
